@if (matchBreakdown()) {
    <div class="submittal-match-breakdown">
        @if (isJobScreen()) {
            @if (!isJobDetailsOnly() && !hideReviewNotes()) {
                <div class="flex-row space-between items-start gap-5 alert-box mb-4">
                    <div>
                        <mat-icon>info</mat-icon>
                    </div>
                    <div>
                        Please note that the match rating is an
                        estimate and does not consider all factors. The clinical team will conduct a final review. Keep
                        this in mind when discussing with the candidate.
                    </div>
                </div>
            }
        }

        @if(!doNotUseMatchCategory()) {
            <nova-match-category-chip [matchCategory]="matchCategory()"></nova-match-category-chip>
        }

        @if(!doNotUseMatchCategory()) {
            <nova-match-category-candidate
                [candidateName]="candidateName()"
                [matchCategory]="matchCategory()">
            </nova-match-category-candidate>
        }

        <mat-card-content>
            <ng-content select="[job-requirements-differences]"></ng-content>
            @if (!isJobDetailsOnly()) {
                <p>
                    {{ !doNotUseMatchCategory() ? 'The match rating' : 'This match' }} is calculated by comparing the information in the
                    <a
                        class="nova__link"
                        href="/#/recruiting/candidates/{{ matchBreakdown()?.candidateId }}/new-profile"
                        target="_blank">
                        candidate's profile
                    </a>
                    against the required qualifications

                    @if (
                        matchBreakdown()?.calculationType === calculationTypeEnum.JobRequirements &&
                        matchBreakdown()?.hasJobLevelEdits
                    ) {
                        listed in the job requirements for
                        <a
                            class="nova__link"
                            href="/#/accountmanagers/facilities/{{ matchBreakdown()?.facilityId }}"
                            rel="noopener"
                            target="_blank">
                            {{ matchBreakdown()?.facilityName }}</a
                        >.
                    }

                    @if (
                        (matchBreakdown()?.calculationType === calculationTypeEnum.UnitTrack ||
                            matchBreakdown()?.calculationType === calculationTypeEnum.UnitRequirements) &&
                        matchBreakdown()?.hasJobLevelEdits
                    ) {
                        in the
                        <a
                            class="nova__link"
                            (click)="openUnitLink($event, matchBreakdown()?.unitFormDescriptionId)"
                            target="_blank"
                            rel="noopener">
                            {{ matchBreakdown()?.unitName }} unit description</a
                        >
                        and includes any job-specific customizations for
                        <a
                            class="nova__link"
                            href="/#/accountmanagers/facilities/{{ matchBreakdown()?.facilityId }}"
                            rel="noopener"
                            target="_blank">
                            {{ matchBreakdown()?.facilityName }}</a
                        >.
                    }

                    @if (matchBreakdown()?.calculationType === calculationTypeEnum.JobTrack) {
                        in the clinical track: {{ matchBreakdown()?.jobTrackName }}.
                    }

                    @if (
                        matchBreakdown()?.calculationType !== calculationTypeEnum.JobTrack &&
                        !matchBreakdown()?.hasJobLevelEdits
                    ) {
                        in the
                        <a
                            class="nova__link"
                            (click)="openUnitLink($event, matchBreakdown()?.unitFormDescriptionId)"
                            target="_blank"
                            rel="noopener">
                            {{ matchBreakdown()?.unitName }} unit description</a
                        >
                        @if (matchBreakdown()?.unitTrackName) {
                            <span> ({{ matchBreakdown()?.unitTrackName }})</span>
                        }
                        for
                        <a
                            class="nova__link"
                            href="/#/accountmanagers/facilities/{{ matchBreakdown()?.facilityId }}"
                            rel="noopener"
                            target="_blank">
                            {{ matchBreakdown()?.facilityName }}</a
                        >.
                    }

                    <nova-match-category-description
                        [matchCategory]="matchCategory()"></nova-match-category-description>
                </p>
            }

            <hr class="divider my-4" />

            @if (isJobScreen() && !isJobDetailsOnly() && !hideReviewNotes()) {
                <div class="missing-explanations-info mb-4">
                    You'll be required to explain any missing qualifications when submitting.
                </div>
            }

            @for (item of matchBreakdown().requiredQualifications; track item) {
                <div>
                    <nova-match-breakdown-grid
                        [data]="item"
                        [isJobScreen]="isJobScreen()"
                        [showRequirementsOverrideIndicator]="showRequirementsOverrideIndicator()"></nova-match-breakdown-grid>
                </div>
                @if (item.hasAdditionalRequirements && showRequirementsOverrideIndicator()) {
                    <div class="additional-requirements-info">
                        <sup>+</sup>Additional requirements not included in the clinical track
                    </div>
                }
            }

            @if (isJobScreen()) {
                <h3 class="md-subhead"> Job Description </h3>
                <span
                    class="text-body"
                    [innerHtml]="jobDescription() | textFormat"></span>
            }
        </mat-card-content>
    </div>
}
